import API from 'services/TAPS_API';
import { NDFL3_NOTIFICATION_ID } from 'modules/Taps/constants';

export default function getDeclarationsHistory(params) {
  return API.request({
    method: 'POST',
    url: `/notification/${NDFL3_NOTIFICATION_ID}/history`,
    data: { ...params },
  });
}
